import { render } from "./CommunityView.vue?vue&type=template&id=50489c56&scoped=true"
import script from "./CommunityView.vue?vue&type=script&lang=js"
export * from "./CommunityView.vue?vue&type=script&lang=js"

import "./CommunityView.vue?vue&type=style&index=0&id=50489c56&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50489c56"]])

export default __exports__